<template>
    <div class="h100vh-100">
       <div class='h-toolbarBg'>
            <div class='e-control e-toolbar' >
                <ejs-toolbar ref='toolbar'>
                    <e-items>
                        <e-item id='edit' prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("Pm.kpiChartEdit")' :click='editChart'></e-item>
                        <e-item id='export' prefixIcon='icon hero-icon hero-icon-export' :tooltipText='$t("Pm.exportChart")' :click='exportChart'></e-item>
                    </e-items>
                </ejs-toolbar>
            </div>
       </div>
       <div class="h100-40 h-scroll" ref='chart9' id='capture'>
            <ul class="h-pm-smbox">
                <li><div><LineChart  v-bind:chartData="chartData.chart_0"></LineChart></div></li>
                <li><div><LineChart  v-bind:chartData="chartData.chart_1"></LineChart></div></li>
                <li><div><LineChart  v-bind:chartData="chartData.chart_2"></LineChart></div></li>
                <li><div><LineChart  v-bind:chartData="chartData.chart_3"></LineChart></div></li>
                <li><div><LineChart  v-bind:chartData="chartData.chart_4"></LineChart></div></li>
                <li><div><LineChart  v-bind:chartData="chartData.chart_5"></LineChart></div></li>
                <li><div><LineChart  v-bind:chartData="chartData.chart_6"></LineChart></div></li>
                <li><div><LineChart  v-bind:chartData="chartData.chart_7"></LineChart></div></li>
                <li><div><LineChart  v-bind:chartData="chartData.chart_8"></LineChart></div></li>
            </ul>
        </div>
        <CustomDialog ref='editDialog' :element='editDialog.element' :styles='editDialog.styles' :messages='editDialog.messages'>
            <template v-slot:dialog-content>
                <EditKPIChart ref="edit" v-bind:nodeParam="nodeParam" v-bind:isEditDialogShow="isEditDialogShow"  @getCheckedNodeData='getCheckedNodeData' @getListData='getListData'></EditKPIChart>
            </template>
        </CustomDialog>
    </div>

</template>

<script>
import html2canvas from 'html2canvas';
import CustomDialog from '../../../../common/CustomDialog';
import EditKPIChart from './editKPIChart';
import { EventBus } from '../../../../../plugins/eventBus';
import LineChart from './lineChart';

const lineChart = '2_3';
export default {
  name: 'right',
  components: {
    CustomDialog,
    EditKPIChart,
    LineChart,
    html2canvas
  },
  props: ['nodeParam'],
  watch: {
    nodeParam(val) {
      // console.log('right nodeParam',val.neName)
      this.initChartDiv();
      if (val.parentNeId === '0') {
        this.$refs.toolbar.enableItems([0], false);
      } else {
        this.$refs.toolbar.enableItems([0], true);
        this.getDefaultChartData();
      }
    },
  },
  data() {
    return {
      systemId: '1',
      viewTypeId: '2',
      isEditDialogShow: false,
      editDialog: {
        element: {
          title: `${this.$t('Pm.kpiChartEdit')}`,
          target: '#app',
          isClose: true,
          refName: 'editDialog',
          buttonGroup: [
            { click: this.cancel, buttonModel: { content: `${this.$t('Common.cancel')}` } },
            { click: this.submit, buttonModel: { content: `${this.$t('Common.ok')}`, isPrimary: true } },
          ]
        },
        styles: {
          // width: '800',
          height: '625',
          visible: false,
          model: true,
          zIndex: 1100
        },
        messages: {
          title: `${this.$t('Pm.kpiChartEdit')}`
        }
      },
      chartDataArray: [],
      checkedKpiNodes: [],
      chartData: {
        chart_0: {
          show: false,
          seriesData: [],
          width: '100%',
          height: '256',
          id: 'chart_0'
        },
        chart_1: {
          show: false,
          seriesData: [],
          width: '100%',
          height: '256',
          id: 'chart_1'
        },
        chart_2: {
          show: false,
          seriesData: [],
          width: '100%',
          height: '256',
          id: 'chart_2'
        },
        chart_3: {
          show: false,
          seriesData: [],
          width: '100%',
          height: '256',
          id: 'chart_3'
        },
        chart_4: {
          show: false,
          seriesData: [],
          width: '100%',
          height: '256',
          id: 'chart_4'
        },
        chart_5: {
          show: false,
          seriesData: [],
          width: '100%',
          height: '256',
          id: 'chart_5'
        },
        chart_6: {
          show: false,
          seriesData: [],
          width: '100%',
          height: '256',
          id: 'chart_6'
        },
        chart_7: {
          show: false,
          seriesData: [],
          width: '100%',
          height: '256',
          id: 'chart_7'
        },
        chart_8: {
          show: false,
          seriesData: [],
          width: '100%',
          height: '256',
          id: 'chart_8'
        },
      },
      captrueHeight: '0',
      listData:[],
      alarmMessage: `${this.$t('Pm.alarmKpi9')}`
    };
  },
  methods: {
    initChartDiv() {
      for (let i = 0; i < 9; i++) {
        const str = `chart_${i}`;
        this.chartData[str].show = false;
      }
    },
    getCheckedNodeData(payload) {
      this.checkedKpiNodes = payload;
      for (const node of this.checkedKpiNodes) {
        node.Hero_Tree_Children = [];
        node.checkedStatus = 'checked';
      }
    },
    getListData(payload){
      this.listData = payload;
    },
    editChart() {
      this.isEditDialogShow = !this.isEditDialogShow;
      this.$refs.editDialog.show();
    },
    exportChart() {
      html2canvas(document.querySelector('#capture')).then(canvas => {
        const imgUrl = canvas.toDataURL('image/png');
        const eleLink = document.createElement('a');
        eleLink.href = imgUrl; // 转换后的图片地址
        eleLink.download = this.$t('Pm.kpiChartAnalyz');
        // 触发点击
        document.body.appendChild(eleLink);
        eleLink.click();
        // 然后移除11
        document.body.removeChild(eleLink);
      });
    },
    cancel() {
      this.$refs.editDialog.close();
    },
    submit() {
      if ((this.listData.length) > 9) {
          EventBus.$emit('toast', {type: 'warning', content: this.alarmMessage});
          return;
      }
      this.insertDefaultChartData();
      this.$refs.editDialog.close();
    },
    setChartData(result) {
      this.chartDataArray = [];
      const resultJson = JSON.parse(result[lineChart].valueJson);

      for (let key in resultJson) {
        for(let child in resultJson[key]){
          //console.log('child',child,resultJson[key][child])
          let infoArr = resultJson[key][child];
          if (infoArr.length > 0) {
            this.chartDataArray.push(infoArr);
          }
        }
      }

      this.initChartDiv();
      for (let i = 0; i < this.chartDataArray.length; i++) {
        const str = `chart_${i}`;
        this.chartData[str].seriesData = this.chartDataArray[i];
        this.chartData[str].show = true;
      }
    },
    getLineData() {
      if (this.checkedKpiNodes.length === 0) {
        return;
      }
      this.$axios.post('/lte/pm/kpichart//getKpiChartDatas.html', {
        checkedKpiNodes: this.checkedKpiNodes,
        neId: this.nodeParam.neId,
        neType: this.nodeParam.neType,
        neVersionId: this.nodeParam.neVersionId,
        systemId: this.systemId,

      }).then((response) => {
        if (response.data.errorCode === 'SUCCESS') {
          const result = response.data.resultVal;
          this.setChartData(result);
        } else {
          EventBus.$emit('toast', {type: 'warning', content: response.data.errorCode});
        }
      }).catch((error) => { // 请求失败处理
        console.log('error', error);
      });
    },
    insertDefaultChartData() {
      this.$axios.post('/lte/pm/kpichart//insertDefaultChartDatas.html', {
        checkedKpiNodes: this.checkedKpiNodes,
        neType: this.nodeParam.neType,
        neVersionId: this.nodeParam.neVersionId,
        systemId: this.systemId,

      }).then((response) => {
        if (response.data.errorCode === 'SUCCESS') {
          this.getLineData();
        } else {
          EventBus.$emit('toast', {type: 'warning', content: response.data.errorCode});
        }
      }).catch((error) => { // 请求失败处理
        console.log('error', error);
      });
    },
    getDefaultChartData() {
      this.$axios.post(`/lte/pm/kpichart//getDefaultChartDatas.html?neType=${this.nodeParam.neType}&neVersionId=${this.nodeParam.neVersionId}&systemId=${this.systemId}&viewTypeId=${this.viewTypeId}`).then((response) => {
        if (response.data.errorCode === 'SUCCESS') {
          this.checkedKpiNodes = response.data.resultVal;
          this.getLineData();
        } else {
          EventBus.$emit('toast', {type: 'warning', content: response.data.errorCode});
        }
      }).catch((error) => { // 请求失败处理
        console.log('error', error);
      });
    }
  },
  mounted() {
    this.$refs.toolbar.enableItems([0], false);
    const This = this;
    const timer = setInterval(() => {
      const capture = document.getElementById('capture');
      // console.log('capture',capture)
      if (capture === null) {
        clearInterval(timer);
        return;
      }
      const height = capture.clientHeight || capture.offsetHeight;
      if (This.captrueHeight !== height) {
        This.captrueHeight = height;
        let length = 9;
        if (This.chartDataArray.length !== 0) {
          length = This.chartDataArray.length;
        }
        for (let i = 0; i < length; i++) {
          const str = `chart_${i}`;
          This.chartData[str].height = String((height - 40) / 3);
        }
      }
    }, 1000);
  },
};
</script>
